import CloseIcon from '@mui/icons-material/Close';
import MaterialChip, { type ChipProps } from '@mui/material/Chip';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';

const StyledMaterialChip = styled(MaterialChip)`
  max-width: 550px;
`;

export const Chip = (props: ChipProps) => {
  return (
    <StyledMaterialChip
      {...props}
      deleteIcon={
        <IconButton size="large">
          <CloseIcon data-test="chip-delete" />
        </IconButton>
      }
    />
  );
};
